/**
 * Created by Rodrigo Quesada on 21/12/16.
 */
export function mapDictionaryEntries<T, R>(obj: { [key: string]: T }, f: (key: string, value: T) => R): R[] {
    return Object.keys(obj).map(k => f(k, obj[k]));
}

export function dictionaryEntries<T>(obj: { [key: string]: T }): DictionaryEntry<string, T>[] {
    return Object.keys(obj).map(k => new DictionaryEntry(k, obj[k]));
}

export function dictionaryValues<T>(obj: { [key: string]: T }): T[] {
    return Object.keys(obj).map(k => obj[k]);
}

export function mapDictionary<T, R, K extends keyof T>(obj: { K: T }, f: (value: T[K]) => R): { K: R } {
    const result: { K: R } = {} as any;
    Object.keys(obj).forEach(k => result[k] = f(obj[k]));
    return result;
}

// region Other Classes
class DictionaryEntry<K extends string | number, T> {
    constructor(readonly key: K, readonly value: T) {
    }
}
// endregion



// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/@angularclass/hmr-loader!./~/tslint-loader!./src/app/common/typescript/objects.util.ts